module.exports = __webpack_public_path__ + "static/media/sell.85e69431.png";